import React from "react";
import { Fade } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";
import "./WelcomeSlideShow.css";

const slideImages = [
  { url: `./Images/Xray.jpg`, focal: [50, 25] },
  { url: `./Images/Local.jpg`, focal: [25, 40] },
  { url: `./Images/Family.jpg`, focal: [50, 15] },
];

let isIOS =
  /iPad|iPhone|iPod/.test(navigator.platform) ||
  (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

// Rotating background layer for the hero. On iOS (where the slideshow lib
// misbehaves) we fall back to a single static background so the hero is
// never empty.
const WelcomeSlideShow = () => {
  if (isIOS) {
    return (
      <div
        className="hero__bg hero__bg--static"
        style={{ backgroundImage: `url(${slideImages[2].url})` }}
      />
    );
  }
  return (
    <div className="hero__bg">
      <Fade
        arrows={false}
        duration={4500}
        transitionDuration={800}
        pauseOnHover={false}
        infinite
        cssClass="hero__fade"
      >
        {slideImages.map((slideImage, index) => (
          <div
            key={index}
            className="hero__slide"
            style={{
              backgroundImage: `url(${slideImage.url})`,
              backgroundPosition: `${slideImage.focal[0]}% ${slideImage.focal[1]}%`,
            }}
          />
        ))}
      </Fade>
    </div>
  );
};

export default WelcomeSlideShow;
